import { useRouter } from "next/router";
import Container from "./layout/Container";
import Stack from "./layout/Stack";
import StoryCards from "./pageContent/StoryCards";
import Pagination from "./Pagination";
import StoryFilters from "./StoryFilters";

function Stories({ stories, tags, pageCount }) {
  const { query } = useRouter();

  const filters = [
    {
      key: "location",
      label: "Location",
      value: query?.location || null,
      tags: tags.location,
    },
    {
      key: "topic",
      label: "Topic",
      value: query?.topic || null,
      tags: tags.topic,
    },
  ];

  return (
    <Stack $between={1} $bottom={6}>
      <Container>
        <StoryFilters filters={filters} />
      </Container>
      <StoryCards stories={stories} />
      {pageCount > 0 && stories.length > 0 && (
        <Pagination pageCount={pageCount} />
      )}
    </Stack>
  );
}

export default Stories;
